<template>
  <div class="home-header">
    <div class="main">
      <div
        class="logo"
        :class="{ en: getTranslate() === 'en' }"
        @click="jumpHome"
      >
        <img :src="serverURL + 'images/LOGO @2x.png'" alt="" />
        {{ $t('lang.external.logoTitle.华侨大学建筑学院') }}
        <br />
        {{ $t('lang.external.logoTitle.虚拟仿真实验申报管理平台') }}
      </div>

      <div class="menus">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#0C5893"
          text-color="#666666"
        >
          <el-menu-item
            v-for="menu in menus"
            :key="menu.id"
            :index="menu.title"
            @click="goPath(menu)"
          >
            <span>{{ $t(menu.title) }}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="login" v-if="!userLogin">
        <span @click="goPath({ path: '/login' })">{{
          $t('lang.external.login.登录')
        }}</span>
        /
        <span @click="goPath({ path: '/register' })">{{
          $t('lang.external.register.注册')
        }}</span>
      </div>
      <div class="login" v-else>
        <router-link to="/personalCenter">
          <img :src="userInfo.photo || serverURL + 'images/head.webp'" alt="" />
        </router-link>
      </div>
    </div>
    <Language />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { menuList } from '@/api/introduction/index'
import { formatLan } from '@/utils/lanFormat'
import Language from '@/components/experimentation/language'
export default {
  name: 'home-header',
  components: { Language },
  props: [],
  data() {
    return {
      menus: [],
      activeIndex: 'lang.external.header.首页',
    }
  },
  watch: {
    $route() {
      this.setCurrentMenu()
    },
  },
  computed: {
    ...mapState(['userLogin', 'userInfo']),
    serverURL() {
      return this.publicData.serverUrl
    },
  },
  created() {
    this.getData()
  },
  mounted() {},
  methods: {
    jumpHome() {
      this.$router.push('/home')
    },
    goPath(val) {
      if (val.path === '/introduction') {
        if (val.path + `?id=${val.id}` === this.$route.fullPath) return
        this.$router.push({ path: val.path, query: { id: val.id } })
      } else if (val.path) {
        if (val.path === this.$route.path) return
        this.$router.push(val.path)
      }
    },
    getTranslate() {
      return window.localStorage.getItem('translate')
    },
    setCurrentMenu() {
      let now = this.menus.filter(({ path }) => path === this.$route.path)
      if (now.length === 1) {
        this.activeIndex = now[0].title
      } else if (now.length > 1) {
        now.forEach((v) => {
          if (
            v.path + `?id=${v.id}` ===
            this.$route.path + `?id=${this.$route.query.id}`
          )
            this.activeIndex = v.title
        })
      } else {
        this.activeIndex = null
      }
    },
    async getData() {
      await menuList({ course_id: 0 }).then((res) => {
        const { data } = res
        let menus = [
          { id: 0, title: 'lang.external.header.首页', path: '/home' },
        ]
        data.forEach((v) => {
          v.title = formatLan(v.title)
          if (v.custom_path) {
            v.path = v.custom_path
          } else {
            v.path = '/introduction'
          }
          menus.push(v)
        })
        this.menus = menus
      })
      this.$store.commit('SET_MENUS', this.menus)
      this.setCurrentMenu()
    },
  },
}
</script>

<style lang="scss" scoped>
.home-header {
  width: 100%;
  color: #666666;
  background: #ffffff;
  box-shadow: 0px 1px 1px 0px rgba(218, 239, 254, 0.14);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  font-size: 18px;
  user-select: none;
  .main {
    width: 100%;
    max-width: 1500px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .en {
      font-size: 13px;
    }
    .logo {
      display: flex;
      align-items: center;
      max-width: 18vw;
      cursor: pointer;
      img {
        width: 48px;
        margin-right: 5px;
      }
    }
    .login {
      img {
        width: 2.34375vw;
        height: 2.34375vw;
        border-radius: 50%;
        cursor: pointer;
      }
      span {
        cursor: pointer;
        &:hover {
          color: #0c5893;
        }
      }
    }
    // .menus {
    //   line-height: 90px;
    // }
  }
}
::v-deep {
  .el-menu--horizontal {
    border: 0;
    .el-menu-item {
      height: 90px;
      padding: 0 20px;
      font-size: 18px;
      line-height: 90px;
      &:hover {
        font-weight: bold;
        color: rgb(12, 88, 147) !important;
        border-bottom-color: rgb(12, 88, 147) !important;
      }
    }
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    font-weight: bold;
  }
}

@media (max-width: 1280px) {
  .home-header {
    font-size: 0.93vw;
  }
  ::v-deep {
    .el-menu--horizontal {
      .el-menu-item {
        height: 60px;
        line-height: 60px;
        font-size: 0.93vw;
        padding: 0 1.5vw;
      }
    }
  }
}
</style>